<nav class="previews-container"
     [class.mobile-visible]="previewConfig?.mobileVisible"
     [attr.aria-label]="accessibilityConfig?.previewsContainerAriaLabel"
     [title]="accessibilityConfig?.previewsContainerTitle">

  <ng-container *ngIf="previewConfig?.visible">
    <a class="nav-left"
       [attr.aria-label]="accessibilityConfig?.previewScrollPrevAriaLabel"
       [tabIndex]="displayLeftPreviewsArrow() ? 0 : -1" role="button"
       (click)="onNavigationEvent('left', $event)" (keyup)="onNavigationEvent('left', $event)">
      <div class="inside {{ displayLeftPreviewsArrow() ? 'left-arrow-preview-image' : 'empty-arrow-preview-image'}}"
           aria-hidden="true"
           [title]="accessibilityConfig?.previewScrollPrevTitle"></div>
    </a>

    <ng-container *ngFor="let preview of previews; trackBy: trackById; let index = index">

      <div class="preview-container {{!previewConfig?.clickable ? ' unclickable' : ''}}"
        (click)="onImageEvent(preview, $event, clickAction)"
        (keyup)="onImageEvent(preview, $event, keyboardAction)"
      >
        <ng-container 
          *ngTemplateOutlet="!customTemplate ? defaultTemplate : customTemplate ; context:{preview, defaultTemplate}">
        </ng-container>
        <ng-template #defaultTemplate>
          <img *ngIf="preview?.modal?.img"
              class="inside preview-image {{isActive(preview) ? 'active' : ''}}"
              [loading]="preview.loading"
              [attr.fetchpriority]="preview.fetchpriority"
              [src]="preview.plain?.img ? preview.plain?.img! : preview.modal.img"
              ksFallbackImage [fallbackImg]="preview.plain?.fallbackImg ? preview.plain?.fallbackImg : preview.modal.fallbackImg"
              ksSize [sizeConfig]="{width: previewConfig?.size ? previewConfig?.size?.width! : defaultPreviewSize.width,
                                    height: previewConfig?.size ? previewConfig?.size?.height! : defaultPreviewSize.height}"
              [attr.aria-label]="preview.modal.ariaLabel ? preview.modal.ariaLabel : ''"
              [title]="(preview.modal.title || preview.modal.title === '') ? preview.modal.title : ''"
              alt="{{preview.modal.alt ? preview.modal.alt : ''}}"
              [tabIndex]="0" role="img"
          />
        </ng-template>
      </div>

    </ng-container>


    <a class="nav-right"
       [attr.aria-label]="accessibilityConfig?.previewScrollNextAriaLabel"
       [tabIndex]="displayRightPreviewsArrow() ? 0 : -1" role="button"
       (click)="onNavigationEvent('right', $event)" (keyup)="onNavigationEvent('right', $event)">
      <div class="inside {{ displayRightPreviewsArrow() ? 'right-arrow-preview-image' : 'empty-arrow-preview-image'}}"
           aria-hidden="true"
           [title]="accessibilityConfig?.previewScrollNextTitle"></div>
    </a>
  </ng-container>

</nav>
